// extracted by css-extract-rspack-plugin
export default {"Container":"bBRZj","HeaderContainer":"N_nWA","HeaderName":"Yitr1"};